// extracted by mini-css-extract-plugin
module.exports = {"menu":"LayoutDropDown_menu__2_Yhg","menu-item":"LayoutDropDown_menu-item__2tx_8","img-div":"LayoutDropDown_img-div__3Pjqh"};